var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFreeIptvSubscription(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 31,
    viewBox: "0 0 27 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.2989 24.7328C23.9346 24.4555 24.2332 25.4485 23.6933 25.6762C23.053 25.9535 22.5889 25.0488 23.2989 24.7328ZM21.7738 11.2254C24.0321 11.8978 25.9083 14.0449 26.0274 16.3594V24.976C25.9965 26.3981 25.5108 27.8699 24.4791 28.8892C22.1326 31.213 20.5116 30.8257 17.0205 30.8257H7.63306C4.09402 30.8257 1.49851 29.811 0.604466 26.0914C0.363167 25.0906 0.490002 18.6042 0.477628 16.8784C0.463707 14.1518 2.0337 12.1627 4.54259 11.2874C5.73052 10.8753 20.2486 10.773 21.7738 11.2254ZM11.9826 13.9086C14.4776 13.7335 16.8009 14.0449 18.9973 14.7699C21.6933 15.6654 22.4312 16.1224 22.0058 19.4423C21.7336 21.5802 21.2247 24.0186 20.5936 25.9551C20.1063 27.4531 20.1326 27.5972 18.4327 27.7599C16.1357 27.9799 8.59361 28.1162 6.99269 27.6282C6.16361 27.3741 5.94088 25.8931 5.66401 24.9884C5.3531 23.9613 5.09788 22.8768 4.88287 21.8002C4.66787 20.7204 4.44823 19.4284 4.40492 18.2866C4.35233 16.8149 4.68952 16.0418 5.6377 15.5198C7.21233 14.646 9.93468 14.0527 11.9826 13.9086Z",
    fill: "#071E43"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.89001 25.773L7.08801 26.4841C8.74462 26.6157 11.5381 25.7776 12.8622 25.2679C15.5891 24.2052 17.3386 23.0371 19.4561 21.316C19.7763 21.0526 21.0338 19.8535 21.2009 19.5499C21.5644 18.9039 21.6525 17.1347 21.1962 16.5863C20.907 16.2439 19.4113 15.5933 18.7059 15.5236C18.5342 15.9279 17.8985 16.766 17.6139 17.1703C17.2365 17.7017 16.8328 18.2455 16.4213 18.7288C15.8506 19.4058 15.1143 20.2703 14.4708 20.8667C10.4585 24.5956 7.41128 25.3547 6.89001 25.7714V25.773Z",
    fill: "url(#paint0_linear_298_916)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.40283 24.1743L6.60391 24.9427C7.97127 24.763 11.1422 22.6422 12.4307 21.6398C13.6232 20.7181 14.7586 19.502 15.7315 18.3556L16.9071 16.9102C17.1654 16.5585 17.832 15.6584 17.9682 15.2634C16.9241 14.9117 15.368 14.6313 14.1368 14.6654C13.9218 14.9164 12.9875 16.7289 12.5807 17.3749C11.9759 18.3323 11.0293 19.6538 10.3224 20.4888L9.28758 21.6259C9.08959 21.8196 8.91017 21.9559 8.72146 22.1433C7.65573 23.2154 8.06872 22.78 7.00299 23.6848C6.82356 23.8335 6.59154 24.0628 6.40283 24.1728V24.1743Z",
    fill: "url(#paint1_linear_298_916)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5419 26.7956C10.5945 26.8265 10.5326 26.8126 10.6826 26.8575C10.7522 26.8792 10.7708 26.8839 10.8311 26.8932C11.5287 27.0031 16.2897 26.8529 16.548 26.8451C17.3152 26.8188 19.2534 26.8808 19.6261 26.4145C20.0082 25.9358 21.0384 21.7421 21.0987 20.8467C20.927 20.9427 19.5766 22.2828 18.9332 22.7785C18.1753 23.3579 17.3415 23.9729 16.4475 24.447C15.5132 24.9427 14.7027 25.3517 13.6896 25.7824C12.6687 26.2131 11.6153 26.4625 10.5419 26.7971V26.7956Z",
    fill: "url(#paint2_linear_298_916)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.22784 23.3222C7.15282 22.8528 9.48073 20.3447 10.2 19.4709C10.7429 18.8172 13.077 15.5531 13.2425 14.5786L10.0639 14.9303C9.85815 15 9.93239 14.9659 9.85814 15.22C9.28893 17.1177 7.55189 20.2486 6.36859 21.8381C6.01747 22.3075 5.7901 22.7475 6.22784 23.3222Z",
    fill: "url(#paint3_linear_298_916)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.82891 21.3733L6.74925 19.9155C7.3494 18.9194 9.00756 16.1262 9.07253 15.1688C8.06402 15.3315 5.77942 16.1262 5.4283 16.8063C5.01995 17.601 5.41437 20.7629 5.82736 21.3733H5.82891Z",
    fill: "url(#paint4_linear_298_916)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.08936 4.93583L6.54411 4.68176L10.872 10.9823L9.73667 11.6113L6.08936 4.93583Z",
    fill: "#071E43"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7297 2.36247L16.1868 2.06348L10.0135 10.9527L11.6268 11.8342L16.7297 2.36247Z",
    fill: "#071E43"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.91302 4.96674C6.42655 4.96674 6.84264 4.55001 6.84264 4.03568C6.84264 3.52135 6.42655 3.10461 5.91302 3.10461C5.39949 3.10461 4.9834 3.52135 4.9834 4.03568C4.9834 4.55001 5.40413 4.96674 5.91302 4.96674Z",
    fill: "#071E43"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0113 2.4725C17.6872 2.4725 18.2441 1.9148 18.2441 1.2347C18.2441 0.554609 17.6872 0 17.0113 0C16.3353 0 15.7754 0.55306 15.7754 1.2347C15.7754 1.91634 16.3322 2.4725 17.0113 2.4725Z",
    fill: "#071E43"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.486 25.8389C23.8154 25.8389 24.083 25.5709 24.083 25.2409C24.083 24.911 23.8154 24.6429 23.486 24.6429C23.1565 24.6429 22.8889 24.911 22.8889 25.2409C22.8889 25.5709 23.1565 25.8389 23.486 25.8389Z",
    fill: "#FEFEFE",
    stroke: "#FEFEFE",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1674 27.2487C23.387 27.2487 23.5618 27.0736 23.5618 26.8583C23.5618 26.643 23.387 26.4679 23.1674 26.4679C22.9477 26.4679 22.7776 26.643 22.7776 26.8583C22.7776 27.0736 22.9524 27.2487 23.1674 27.2487Z",
    fill: "#FEFEFE",
    stroke: "#FEFEFE",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_298_916",
    x1: 14.1984,
    y1: 15.5236,
    x2: 14.1984,
    y2: 26.4979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD5900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE3D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_298_916",
    x1: 12.1855,
    y1: 14.6626,
    x2: 12.1855,
    y2: 24.9427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCC905"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDEBA7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_298_916",
    x1: 15.8203,
    y1: 20.8467,
    x2: 15.8203,
    y2: 26.9333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC0001"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57D7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_298_916",
    x1: 9.61479,
    y1: 14.5786,
    x2: 9.61479,
    y2: 23.3222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#69A711"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1E4B6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_298_916",
    x1: 7.75269,
    y1: 14.3789,
    x2: 5.65576,
    y2: 21.5683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#168CBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8EC7DF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreeIptvSubscription);
export default __webpack_public_path__ + "static/media/free_iptv_subscription.2c57c4cda7c406c861fe7d9ea7bbabca.svg";
export { ForwardRef as ReactComponent };